import axios from "axios";
import { logout, setAccessToken } from "../redux/userStore";
import {
  base_url,
  country_url,
  refresh_token_url,
  user_logout_url,
} from "./urls";

export const api = axios.create({
  baseURL: base_url,
});

export const apiPublic = axios.create({
  baseURL: base_url,
});

export const setup = (store) => {
  api.interceptors.request.use(
    (config) => {
      const token = store.getState().user.accessToken;
      if (!config.url.startsWith("/in") && config.url !== country_url) {
        config.url = "/in" + config.url;
      }
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const { dispatch } = store;

  api.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalRequest = err.config;

      // Skip if flagged
      // if (originalRequest._skipAuth) {
      //   return Promise.reject(err);
      // }

      // Prevent infinite loop
      if (err.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const rs = await apiPublic.post(
            refresh_token_url,
            {
              refresh: store.getState().user.refreshToken,
            },
            {
              _skipAuth: true, // skip interceptor on refresh call
            }
          );

          if (rs?.data) {
            const { access } = rs.data;

            // Save token
            dispatch(setAccessToken(access));

            // Retry the original request with new token
            originalRequest.headers.Authorization = `Bearer ${access}`;
            return api(originalRequest);
          }
        } catch (error) {
          // Handle refresh token failure
          if (error?.response?.status === 401) {
            try {
              await api.get(user_logout_url);
            } catch (e) {
              console.error("Logout failed", e);
            }

            await dispatch(logout());
          }

          return Promise.reject(error);
        }
      }

      // Handle 500 error
      if (
        err.response?.status === 500 &&
        base_url !== "https://api1.tagonstore.com"
      ) {
        const myWindow = window.open("", "response", "resizable=yes");
        myWindow.document.write(err.response?.data);
      }

      return Promise.reject(err);
    }
  );
};
